import React from 'react';
import { offerAnchor, volumes } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Volumes() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-246" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-3xl" data-id="element-247" data-mp="185q1lqmmm3tb">
        <Eyebrow data-id="element-248" data-mp="1c4ywwzxbe9qz">What's included</Eyebrow>
        <SectionTitle data-id="element-249" data-mp="1c607l3af4u86">
          5 complete volumes. <Mark data-id="element-250" data-mp="1zvb24316dsdv">One organized system.</Mark>
        </SectionTitle>

        <ul className="mt-8 space-y-4" data-id="element-251" data-mp="1zvuobvxuz2xp">
          {volumes.map(volume => <li key={volume.number} className="overflow-hidden rounded-2xl border border-brand/10 shadow-sm" data-id="element-252" data-mp="24suoxrbxvdhf">
              <div className="flex items-center gap-3 bg-brand px-4 py-3 md:px-5" data-id="element-253" data-mp="1qu3gakfuik0o">
                <span className="shrink-0 rounded-md bg-gold-light px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-brand-deep md:text-[11px]" data-id="element-254" data-mp="1vs4wmxlw058g">
                  Volume {volume.number}
                </span>
                <h3 className="text-sm font-black uppercase leading-tight text-white md:text-base" data-id="element-255" data-mp="kc7xkgkc44xi">{volume.name}</h3>
              </div>
              <div className="bg-white px-4 py-4 md:px-5" data-id="element-256" data-mp="3j9bxcsfv77g1">
                <p className="text-sm font-semibold leading-relaxed text-brand-deep" data-id="element-257" data-mp="3jawrwi26iqdw">{volume.intro}</p>
                <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-258" data-mp="1yvlka9l300g">
                  {volume.items.map(item => <li key={item} className="rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-700" data-id="element-259" data-mp="3t9m886efg2s1">
                      {item}
                    </li>)}
                </ul>
                <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-260" data-mp="kqoey5sken8p">{volume.sessions}</p>
                <p className="mt-2 text-[11px] font-black uppercase tracking-wider text-gold-dark" data-id="element-261" data-mp="ft529abimiiv">{volume.tagline}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-262" data-mp="pru9m95sckkv">
          <p className="text-sm font-black uppercase tracking-wide text-brand-deep md:text-base" data-id="element-263" data-mp="poq1j0p794ox">
            60 techniques. 40 clinical sessions. <Mark data-id="element-264" data-mp="11s11lit06lp3">Ready before your next patient.</Mark>
          </p>
          <div className="mt-4" data-id="element-265" data-mp="16rx6dk9iyh5p">
            <Button href={offerAnchor} size="lg" subtext="Unlock all 5 volumes + 5 free bonuses at today's price" data-id="element-266" data-mp="16qvsl814jgka">
              Yes! Organize my sessions now
            </Button>
          </div>
        </div>
      </div>
    </section>;
}